import React, { Component } from "react";
import './weddings.css';
import { FormattedMessage } from 'react-intl';

class Weddings extends Component {

  render() {
    return (
      <div className="row gray" >
        <div className="col-sm-6 col-lg-4 wedding-image-col">
          <img className="weddings-image" src="img/weddings/married.jpg" alt="Married" />
        </div>
        <div className="col-sm-6 col-lg-8">
          <div className="weddings-content-text">
            <h1 className="weddings-title">
              <span className="weddings-title-capital"><FormattedMessage id={'weddings.capital'} /></span>
              <span className="weddings-title-text"><FormattedMessage id={'weddings.title'} /></span>
            </h1>
            <p className="weddings-text" ><FormattedMessage id={'weddings.text'} /></p>
            <img className="weddings-swirl" src="img/weddings/weddingringsswirl.svg" alt="Swirl" />
          </div>
        </div>
      </div>


    );
  }
}

export default Weddings;



// WEBPACK FOOTER //
// ./src/weddings/weddings.js